export default "__VITE_ASSET__BuwbYwPm__"